import { module as BaseModule } from "modujs"
import Masonry from "masonry-layout"
import imagesLoaded from "imagesloaded"

export default class extends BaseModule {
  init() {
    // Initialize masonry once the document is ready
    this.initMasonry()
  }

  initMasonry() {
    const grid = this.el.querySelector(".grid-masonry")

    if (!grid) return

    // Initialize imagesLoaded to ensure proper layout after images load
    imagesLoaded(grid, () => {
      // Initialize Masonry with options
      this.msnry = new Masonry(grid, {
        itemSelector: ".masonry-item", // Select masonry items
        columnWidth: ".grid-sizer", // Use a grid sizer element
        percentPosition: true, // Use percentage-based sizing
        gutter: parseInt(
          window
            .getComputedStyle(document.documentElement)
            .getPropertyValue("--gap-w") || "20",
          10
        ), // Get gap from CSS variable or default to 20
        transitionDuration: "0.4s", // Smooth transitions
      })

      // Refresh layout after all images are loaded
      this.msnry.layout()
    })

    // Add resize handler to update layout on window resize
    this.handleResize = () => {
      if (this.msnry) {
        this.msnry.layout()
      }
    }

    window.addEventListener("resize", this.handleResize)
  }

  destroy() {
    // Clean up when module is destroyed
    if (this.msnry) {
      this.msnry.destroy()
    }

    window.removeEventListener("resize", this.handleResize)
  }
}
